import React, { Component } from 'react'
import {
  Button,
  ButtonToolbar
} from 'react-bootstrap'

import { BootstrapTable } from 'react-bootstrap-table'
import 'react-bootstrap-table/dist/react-bootstrap-table.min.css'
import FontAwesome from 'react-fontawesome'
import { blockingFetchService } from '../../lib/blockingFetch'
import apiServerApi from '../../redux/sagas/apiServerApi'

import CheckBundleActivity from './CheckBundleActivity'
import UpdateBundleStatus from './UpdateBundleStatus'

class BundleTable extends Component {

  options = {
    sortName: 'id',
    sortOrder: 'desc'
  }

  constructor(props) {

    super(props)
    this.state = {
      showRemoveModal: false,
      itemSelected: false,
      selectedRow: { id: null },
      selectRowProp: {
        mode: "radio",
        clickToSelect: true,
        hideSelectColumn: true,
        bgColor: "#9bbfdd",
        onSelect: this.onRowSelect
      },
      checkActivityRunning: false,
      checkActivityError: '',
      activity: 0,
      nbLoan: 0,
      shouldChangeStatus: false,
    }

    this.bundleTableRef = null 
    this.setBundleTableRef = elt => {
      this.bundleTableRef = elt
    }
  }

  onRowSelect = (row, isSelected, e) => {

    if (isSelected === true) {
      this.setState({ selectedRow: row })
    }
    this.setState({ itemSelected: isSelected })
  }

  closeRemoveModal = () => this.setState({ showRemoveModal: false })

  showRemoveDialog = () => this.setState({
    activity: 0,
    showRemoveModal: true,
  })

  /**
   * Check the bundle activities
   */
  processRemoveBundle = () => {

    this.showRemoveDialog()
    this.setState({
      checkActivityRunning: true,
      checkActivityError: '',
    })

    blockingFetchService(
      accessToken => apiServerApi.countBundleLoans(accessToken, this.getBundleToRemove().id), 
      nbLoan => this.countBundleLoansSuccess(nbLoan),
      error => this.countBundleLoansFailure(error),
      () => {}
    )
  }

  countBundleLoansSuccess = nbLoan => this.setState({
    checkActivityRunning: false,
    checkActivityError: '',
    activity: nbLoan > 0 ? 1 : 2,
    nbLoan: nbLoan,
  })

  countBundleLoansFailure = error => this.setState({
    checkActivityRunning: false,
    checkActivityError: error.text,
  })

  /**
   * Remove action 
   */
  doRemoveAction = type => {

    const id = this.getBundleToRemove().id

    if(type === 1) { // Mark bundle as inactive
      blockingFetchService(
        accessToken => apiServerApi.changeBundleStatus(accessToken, id, false), 
        response => this.changeStatusSuccess(response),
        error => this.changeStatusFailure(error),
        () => {}
      )
    }
    else if(type === 2) { // remove bundle from the system
      this.props.onConfirmRemoval(id)
      this.closeRemoveModal()
    }

    this.setState({ itemSelected: false })
  }

  changeStatusSuccess = () => {
    this.closeRemoveModal()
    this.props.loadBundles()
    this.setState({
      checkActivityRunning: false,
      checkActivityError: '',
    })
  }

  changeStatusFailure = error => this.setState({
    checkActivityRunning: false,
    checkActivityError: error.text,
  })

  getBundleToRemove = () => this.state.selectedRow

  handleChangeStatus = () => this.setState({
    shouldChangeStatus: true,
  })

  closeChangeStatus = () => {

    this.setState({
      shouldChangeStatus: false,
      itemSelected: false,
    })

    if (this.bundleTableRef) {
      this.bundleTableRef.cleanSelected()
    }
  }

  renderToolbar = () => {

    const { canEditBundle } = this.props
    if(!canEditBundle) return null

    const { addNewLabel, addNewHandler, setBundle } = this.props,
    { itemSelected, showRemoveModal, checkActivityRunning,
      checkActivityError, activity, nbLoan, selectedRow, shouldChangeStatus } = this.state,

    disableDelete = !itemSelected 
      || (itemSelected && (selectedRow.active === false || selectedRow.fineractId > 0)),
    
    { active, id } = selectedRow

    return (
      <ButtonToolbar className='margin-bottom-40'>

        <Button bsStyle='primary' className="min-w-120"
          title='Create a new bundle'
          onClick={ addNewHandler }>
          <FontAwesome name='plus-circle' /> { addNewLabel }
        </Button>

        <Button bsStyle='danger' className="min-w-120"
          onClick={ this.processRemoveBundle }
          title='Remove a bundle or mark it as inactive!'
          disabled={ disableDelete }>
          <FontAwesome name='trash-o' /> Remove
        </Button>

        { itemSelected && 
        <Button bsStyle={ active ? 'warning' : 'info' } title={ active ? 'Disable' : 'Enable' } 
          className="min-w-120"
          onClick={ this.handleChangeStatus }
          disabled={ !itemSelected }>
          <FontAwesome name={ active ? 'lock' : 'unlock' } /> { active ? 'Disable' : 'Enable' }
        </Button>}

        <CheckBundleActivity
          bundle={ this.getBundleToRemove() }
          show={ showRemoveModal }
          close={ this.closeRemoveModal }
          doAction={ this.doRemoveAction }
          activityRunning={ checkActivityRunning }
          activityError={ checkActivityError }
          activity={ activity }
          nbLoan={ nbLoan }
        />

        <UpdateBundleStatus
          bundleId={ id } 
          active={ active }
          setBundle={ setBundle }
          show={ shouldChangeStatus }
          close={ this.closeChangeStatus }
        />
      </ButtonToolbar>
    )
  }

  renderContent() {

    const { items, children, canEditBundle } = this.props,
    { selectRowProp } = this.state

    return (
      <div>
        <BootstrapTable
          data={ items }
          striped
          hover
          condensed
          selectRow={ selectRowProp }
          options={ this.options }
          exportCSV={ canEditBundle }
          csvFileName='Bundles.csv'
          pagination
          ref={ this.setBundleTableRef }>
          { children }
        </BootstrapTable>
        { this.renderToolbar() }
      </div>
    )
  }

  render() {
    return (
      this.props.loading ? <p>Loading...</p> : this.renderContent()
    )
  }
}

export default BundleTable



// WEBPACK FOOTER //
// ./src/components/Bundles/BundleTable.js